// FORMULÁRIO EXTERNO ANTES DO WHATSAPP — allowlist por codsite.
//
// Pedido do cs2431 (Gasso Imóveis): TODO botão de WhatsApp do site abre primeiro o formulário
// do Bitrix24 do cliente; enviado o formulário, o visitante segue para o WhatsApp com o mesmo
// número e a mesma mensagem de antes. O lead entra no Bitrix (pelo próprio formulário) E no CRM
// (sendUser), por isso o formulário próprio do flutuante (site.formulario_whats) fica desligado
// para esses sites — ver WhatsappComponent.
//
// Os ~300 sites rodam este mesmo código: só entra aqui quem pediu. O componente
// (components/fixed/formularioExternoNoWhats) é carregado por dynamic() no _app SÓ para os
// codsites deste mapa — os demais não baixam o chunk nem nada do Bitrix.
//
// O script que o Bitrix entrega para colar (data-b24-form="inline/…") NÃO serve colado no
// campo de GTM do CRM: o modo inline desenha o formulário na posição da tag, e aquele campo
// injeta no fim do <body>.
export type FormularioExternoNoWhats = {
    // valor do data-b24-form: "inline/<id do formulário>/<sec>"
    form: string;
    telemetria: string;
    loader: string;
    // Fundo do modal. As cores do formulário são do cliente, definidas lá no Bitrix: o do 2431
    // é texto branco sobre fundo transparente, só fica legível em fundo escuro.
    fundo: string;
};

export const FORMULARIO_EXTERNO_NO_WHATS: Record<number, FormularioExternoNoWhats> = {
    2431: {
        form: 'inline/4/na3gp3',
        telemetria: 'v1:4:site.2e3b82ed0ef5f2ffcc937bcbbbcc55095f1948d382b9deca440043632fba9382',
        loader: 'https://cdn.bitrix24.com.br/b38683077/crm/form/loader_4.js',
        fundo: '#2f4679',
    },
};

export const getFormularioExternoNoWhats = (site: any): FormularioExternoNoWhats | null =>
    FORMULARIO_EXTERNO_NO_WHATS[Number(site?.id)] ?? null;

export const siteUsaFormularioExternoNoWhats = (site: any): boolean =>
    getFormularioExternoNoWhats(site) !== null;
